import React from 'react';
import ToastBase from './ToastBase';

import TToast from './@types/TToast';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

/**
 * @deprecated you should use SuccessToast instead
 */
const Info = ({ children, icon, ...rest }: TToast) => {
  return (
    <ToastBase signal={FeedbackSignals.Success} icon={icon} {...rest}>
      {children}
    </ToastBase>
  );
};

export default Info;
